import { IUser } from "../../../../types/user/iuser.interface";

export function createUnderNdaBannerTooltipText(underNdaUsers: IUser[]): string {
  return underNdaUsers
    .map((user, index) =>
      index === underNdaUsers.length - 1
        ? `${underNdaUsers.length === 1 ? "" : " and"} ${user.firstName} ${user.lastName}.`
        : ` ${user.firstName} ${user.lastName}${index === underNdaUsers.length - 2 ? "" : ", "}`
    )
    .join("");
}
